import { render, staticRenderFns } from "./TranslationImportExport.vue?vue&type=template&id=ee79d2a0&"
import script from "./TranslationImportExport.vue?vue&type=script&lang=js&"
export * from "./TranslationImportExport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports